module.exports = __webpack_public_path__ + "img/book_qiehu.b99dd1f1.png";